const paths = {
  listAsset: '/asset/list',
  editAsset: '/asset/edit'
};

export default paths;
